import React, { Component } from 'react'
import Predefine_Vnack_Soccer from '../components/Predefine_Vnack_Soccer/Predefine_Vnack_Soccer'

export class Predefine_Vnack_SoccerPage extends Component {
  render() {
    return (
      <Predefine_Vnack_Soccer/>
    )
  }
}

export default Predefine_Vnack_SoccerPage